'use strict';

var classChecks = require('../../common/var/classChecks');

var isDate = classChecks.isDate;

function getRangeMemberPrimitiveValue(m) {
  if (m == null) return m;
  return isDate(m) ? m.getTime() : m.valueOf();
}

module.exports = getRangeMemberPrimitiveValue;


//////////////////
// WEBPACK FOOTER
// ./~/sugar-date/range/internal/getRangeMemberPrimitiveValue.js
// module id = 375
// module chunks = 0